var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.5C30 14.7544 29.9595 14.9929 29.8786 15.2155C29.7977 15.438 29.6616 15.6447 29.4703 15.8355L16.7576 28.4276C16.3724 28.8092 15.9152 29 15.3862 29C14.8571 29 14.3993 28.8092 14.0128 28.4276C13.6276 28.0461 13.435 27.6009 13.435 27.0921C13.435 26.5833 13.6276 26.1382 14.0128 25.7566L23.451 16.4079L1.87801 16.4079C1.33226 16.4079 0.882825 16.2247 0.529695 15.8584C0.176565 15.4921 1.6648e-07 15.0393 1.72911e-07 14.5C1.79357e-07 13.9594 0.184269 13.506 0.552808 13.1397C0.921347 12.7734 1.37913 12.5908 1.92616 12.5921L23.451 12.5921L14.0128 3.24342C13.6276 2.86184 13.435 2.41667 13.435 1.90789C13.435 1.39912 13.6276 0.953951 14.0128 0.572371C14.3981 0.190792 14.8558 1.77154e-07 15.3862 1.83478e-07C15.9165 1.89803e-07 16.3737 0.190792 16.7576 0.572371L29.4703 13.1645C29.6629 13.3553 29.7997 13.562 29.8805 13.7845C29.9614 14.0071 30.0013 14.2456 30 14.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFooter);
export default __webpack_public_path__ + "static/media/arrow_footer.e8498617def10896c1f9248f7bca0db0.svg";
export { ForwardRef as ReactComponent };